/* SPS V4: filtres natifs Shopify, URL serveur, sans filtrage limite a la page visible. */
(function(){
  'use strict';
  function init(){
    var root = document.getElementById('sps-facet-root');
    if (!root || root.dataset.spsReady === 'true') return;
    root.dataset.spsReady = 'true';
    var form = document.getElementById('sps-facets-form');
    var toggle = document.getElementById('sps-facet-toggle');
    var sort = document.getElementById('sps-sort-by');
    if (!form) return;
    function submit(){ if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    if (toggle) {
      var isMobile = function(){return window.matchMedia('(max-width: 749px)').matches;};
      toggle.setAttribute('aria-expanded', isMobile() ? 'false' : 'true');
      toggle.addEventListener('click', function(){
        var open = root.classList.toggle('sps-facets-open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }
    root.querySelectorAll('.sps-native-facets input[type="checkbox"]').forEach(function(input){
      input.addEventListener('change', submit);
    });
    if (sort) sort.addEventListener('change', submit);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
